export default __webpack_public_path__ + "static/media/other-manufacturer.98dc30f5.webp";